import React from "react";
import { useSelector, useDispatch } from "react-redux";
import userIcon from "assets/img/user-icon.png";
import contactIcon from "assets/img/contact-icon.png";
import educationIcon from "assets/img/education-icon.png";
import referenceIcon from "assets/img/reference-icon.png";
import additionalIcon from "assets/img/additional-icon.png";
import { goThrSideBar } from "../redux/slice/onboardingFormSlice";

const ProgressBar = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => {
    if (!state || typeof state !== "object") return 1;

    const candidates = [
      state.formSlice,
      state.onboardingForm,
      state.onboarding,
      state.form,
      state.preonboarding,
    ];

    for (const c of candidates) {
      if (c && (typeof c.step === "number" || typeof c.step === "string")) {
        const parsed = Number(c.step);
        if (!Number.isNaN(parsed)) return Math.max(1, Math.floor(parsed));
      }
    }

    for (const key of Object.keys(state)) {
      const s = state[key];
      if (s && (typeof s.step === "number" || typeof s.step === "string")) {
        const parsed = Number(s.step);
        if (!Number.isNaN(parsed)) return Math.max(1, Math.floor(parsed));
      }
    }
    return 1;
  });

  const steps = [
    { label: "Personal Details", icon: userIcon },
    { label: "Contact Details", icon: contactIcon },
    { label: "Educational Details", icon: educationIcon },
    { label: "Experience Details", icon: referenceIcon },
    { label: "Additional Details", icon: additionalIcon },
    { label: "Preview", icon: additionalIcon },
  ];

  const isDev = process.env.NODE_ENV === "development";
  const isEnvEnabled = process.env.REACT_APP_ENABLE_ALL_STEPS === "true";
  const isTesting = isDev && isEnvEnabled;
  const handleStepClick = (index) => {
    const stepNumber = index + 1;
    const isAllowed = isTesting || stepNumber <= currentStep;
    if (isAllowed) {
      dispatch(goThrSideBar(stepNumber));
    }
  };

  return (
    <ul className="progress-container nav" style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isDisabled = !isTesting && stepNumber > currentStep;

        return (
          <li key={step.label} className="nav-item">
            <button
              type="button"
              tabIndex={isDisabled ? -1 : 0}
              className={`btn-interactive nav-link step-container ${isActive ? "active" : ""} ${isDisabled ? "disabled" : "enabled"}`}
              onClick={() => !isDisabled && handleStepClick(index)}
              style={{
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.45 : 1,
                display: "flex",
                alignItems: "center",
                gap: 8,
                userSelect: "none",
              }}
            >
              <img src={step.icon} alt={`${step.label} icon`} style={{ width: 18, height: 18 }} />
              <span style={{ fontWeight: isActive ? 700 : 600 }}>{step.label}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ProgressBar;
